import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import * as React from "react";
import { createGuid } from "../../../../utils/CommonUtils";
import CarsCard from "../../Cards/CarsCard/CarsCard";
import FacilityCard from "../../Cards/FacilityCard/FacilityCard";
import classes from "../Accordion.module.css";
import { USER_TYPES } from "../../../../enums/Enums";

const FacilityAccordion = (props) => {
  const [expanded, setExpanded] = React.useState("");
  //let utronUser = JSON.parse(JSON.stringify(props?.utronUser)); // Deep copy
  let utronUser = props?.utronUser;
  const carsTokensSite = props?.utronUser?.cars?.filter(car => !car.isETicketCar)
    .map((car) => {
      // let utronUser = props?.utronUser;
      let carUserTokens = utronUser?.carUserTokens.filter((carUserToken) => carUserToken.carId === car.id)?.map((carUserToken) => carUserToken?.token);
      // ?.filter((token) => token?.siteId === props.siteId);

      let assignCarToken = utronUser.carUserTokens.filter((carUserToken) => carUserToken.carId !== null && carUserToken.carId === car.id).map(carUserToken => carUserToken.token);

      let parkingHistory = props?.utronUser?.parkingHistories;
      let filteredParkingHistory = parkingHistory.filter(parkingHistory => parkingHistory.carId === car.id && parkingHistory.siteId === props.siteId);
      let sortedParkingHistory = filteredParkingHistory.sort((a, b) => new Date(b.entranceDate).getTime() - new Date(a.entranceDate).getTime());

      const isCheckIn = car && sortedParkingHistory
        && sortedParkingHistory.length > 0 &&
        sortedParkingHistory[0].retrievalDate === null ? true : false;

      // prev code
      // const isCheckIn =
      //   car &&
      //   props?.utronUser?.parkingHistories?.filter(
      //     (parkingHistory) =>
      //       parkingHistory.retrievalDate === null &&
      //       parkingHistory.carId === car.id &&
      //       parkingHistory.siteId === props.siteId
      //   ).length > 0;

      car = { ...car, isCheckIn };
      car = { ...car, carUserTokens };
      car = { ...car, assignCarToken };
      car = { ...car, utronUser };
      return { car };
    });
  // .filter((carToken) => carToken?.car?.currentSiteId === props.siteId);

  const unassignedUserTokensSite = utronUser?.carUserTokens.filter((cut) => !cut.isOccupied && cut.carId === null && !cut.token?.deleted && cut.token?.siteId === props.siteId && cut.token?.userTypeId !== USER_TYPES.TRANSIENT).map(cut => cut.token);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <div className={classes.cardContainer}>
      <Accordion
        defaultExpanded
        className={classes.accordion}
        expanded={
          props.isViewMode ||
          (expanded === props.site.clientId &&
            carsTokensSite &&
            carsTokensSite.length !== 0)
        }
        onChange={handleChange(props.site.clientId)}
      >
        <AccordionSummary
          aria-controls={props.site.clientId}
          id={props.site.clientId}
          className={classes.accordionSummary}
        >
          <FacilityCard
            {...props}
            expanded={expanded}
            hasCars={carsTokensSite && carsTokensSite?.length !== 0}
            disableDeletion={props.utronUser?.userSites?.length <= 1}
          ></FacilityCard>
        </AccordionSummary>
        {carsTokensSite && (
          <AccordionDetails className={classes.accordionDetails}>
            <CarsCard
              key={createGuid()}
              carsTokens={carsTokensSite}
              unassignedUserTokensSite={unassignedUserTokensSite}
              isViewMode={props.isViewMode}
              parentSite={props.site}
            ></CarsCard>
          </AccordionDetails>
        )}
      </Accordion>
    </div>
  );
};

export default FacilityAccordion;
